import { fmtNum } from '@entities/mto';
import { Card } from '@shared/ui/Card';
import {
  Notice,
  Tile,
  TileButton,
  TileLabel,
  Tiles,
  TileValue,
} from '../styles';

export function VedomostTiles({
  materialsCount,
  reviewCount,
  rebarTons,
  rebarMultTons,
  totalWeightTons,
  validDocsCount,
  projectName,
  onlyCheck,
  onShowReview,
  notIncludedCount,
  perUnit,
  perUnitFound,
  perUnitManual,
  worksCount,
}: {
  materialsCount: number;
  reviewCount: number;
  rebarTons: number | null;
  rebarMultTons: number | null;
  totalWeightTons: number | null;
  validDocsCount: number;
  projectName?: string;
  onlyCheck: boolean;
  onShowReview: () => void;
  notIncludedCount: number;
  perUnit: number;
  perUnitFound: number;
  perUnitManual: number;
  worksCount: number;
}) {
  return (
    <Card>
      <Tiles>
        <Tile>
          <TileValue>{materialsCount}</TileValue>
          <TileLabel>позиций материалов</TileLabel>
        </Tile>
        <TileButton type="button" $active={onlyCheck} aria-pressed={onlyCheck} onClick={onShowReview}>
          <TileValue>{reviewCount}</TileValue>
          <TileLabel>строк «проверить» — показать</TileLabel>
        </TileButton>
        <Tile>
          <TileValue>{rebarTons != null ? fmtNum(rebarTons) : '—'}</TileValue>
          <TileLabel>арматура объекта, т (без «на 1 элемент»)</TileLabel>
        </Tile>
        {rebarMultTons != null && (
          <Tile>
            <TileValue>{fmtNum(rebarMultTons)}</TileValue>
            <TileLabel>арматура с учётом кратности по РД, т — проверьте</TileLabel>
          </Tile>
        )}
        <Tile>
          <TileValue>{totalWeightTons != null ? fmtNum(totalWeightTons) : '—'}</TileValue>
          <TileLabel>вес изделий по спецификациям, т</TileLabel>
        </Tile>
        <Tile>
          <TileValue>{validDocsCount}</TileValue>
          <TileLabel>
            документов РД{projectName ? ` · ${projectName}` : ''}
          </TileLabel>
        </Tile>
      </Tiles>

      {(notIncludedCount > 0 || perUnit > 0 || worksCount > 0) && (
        <Notice role="note">
          <strong>Учтите перед заказом:</strong>
          <ul>
            {notIncludedCount > 0 && (
              <li>
                Ведомость неполная: не вошли документы — {notIncludedCount} (см. «Документы
                ведомости» ниже).
              </li>
            )}
            {perUnit > 0 && (
              <li>
                Строк «на 1 элемент» — {perUnit}: это состав одной конструкции, в итоги объекта
                они не входят.{' '}
                {perUnitFound > 0
                  ? `У ${perUnitFound} из них число конструкций нашлось в том же документе (спецификация к схеме расположения): под количеством — «×N = …», количество, умноженное на него, и итог «с учётом кратности» — проверьте.`
                  : 'Число конструкций в документе не нашлось.'}{' '}
                Где числа нет, нажмите «Указать кратность» и впишите, сколько таких конструкций на
                объекте. Строки с кратностью идут в сверку с заявками умноженными.
                {perUnitManual > 0 ? ` Кратность указана вами: ${perUnitManual}.` : ''}
              </li>
            )}
            {worksCount > 0 && (
              <li>
                Строк работ из ведомости объёмов работ — {worksCount} (раздел «Работы из ВОР»): это
                работы, а не материалы, в сверку с заявками они не входят. Если строка называет
                материал, которого нет в спецификации (например, кабель), нажмите «Учесть».
              </li>
            )}
          </ul>
        </Notice>
      )}
    </Card>
  );
}
